<template>
  <div class="error-container">
    <div class="not-found">
      {{ error.status }}
      <div>
        {{ error.data }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Error',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (to.params.err && to.params.err.data) vm.error = to.params.err
    })
  },
  metaInfo: () => ({ title: 'Страница не найдена' }),
  data () {
    return {
      error: {
        status: 404,
        data: 'Страница не найдена'
      }
    }
  }
}
</script>
